import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const txPostXeroStore = {
    namespaced: true,
    state:{
        searchModel:{
            compCode:"",
            DateFrom:"",
            DateTo:"",         
            EntNum:"",           
            TxNumFrom:"",
            TxNumTo:"",
            isPosted: false,
            newOnly: false,
            InclAIedTx: false,           
        }
    },
    actions:{     
        getInvoiceList({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/getprintinvlist', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },   
        postInvoiceToXero({commit, state}, param){
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/PostToXero', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },   
        postGRToXero({commit, state}, param){
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/gr/PostToXero', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    }
};
export default txPostXeroStore;